export const sources = {
	avif: "__VITE_ASSET__DMYYO3kP__ 263w",
	webp: "__VITE_ASSET__BN9Mjssv__ 263w"
};
export const img = {
	src: "__VITE_ASSET__D_fFXyao__",
	w: 263,
	h: 286
};
export default {
	sources: sources,
	img: img
};
